import type * as React from "react";

/** Calm loading ring. Warm track + accent arc, 0.9s rotation (SVG-driven, no global keyframe dependency). Pair with a quiet label. */
export interface SpinnerProps {
  /** Diameter in px. @default 24 */
  size?: number;
  /** Quiet label to the right (e.g. "Generating frame…"). */
  label?: string;
  /** Arc color. @default "var(--accent)" */
  color?: string;
  style?: React.CSSProperties;
}

export function Spinner({ size = 24, label, color = "var(--accent)", style }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      style={
        {
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          color: "var(--text-muted)",
          fontFamily: "var(--font-sans)",
          fontSize: "var(--text-body-sm)",
          ...style,
        } as React.CSSProperties
      }
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="var(--warm-200)" strokeWidth="2.5" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke={color} strokeWidth="2.5" strokeLinecap="round">
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.9s" repeatCount="indefinite" />
        </path>
      </svg>
      {label ? <span>{label}</span> : null}
    </span>
  );
}
